import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ProductSwatchSizesItemMarkup from './ProductSwatchSizesItemMarkup';
import ProductSwatchSizesSelection from '../ProductSwatchSizesSelection';

const ProductSwatchSizes = ({
  swatches,
  setProductSKU,
  selectedSKU,
  label,
  separator,
  onChange,
  showSizeSelection = true,
}) => (
  <Fragment>
    {showSizeSelection && (
      <ProductSwatchSizesSelection
        label={label}
        separator={separator}
      />
    )}

    <ProductSwatchSizesItemMarkup
      swatches={swatches}
      setProductSKU={setProductSKU}
      selectedSKU={selectedSKU}
      onChange={onChange}
    />
  </Fragment>
);

ProductSwatchSizes.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    // TODO: [2] define proper shape structure for swatch object
    skuSize: PropTypes.string,
    sku: PropTypes.string,
  })).isRequired,
  selectedSKU: PropTypes.string.isRequired,
  setProductSKU: PropTypes.func.isRequired,
  label: PropTypes.string,
  separator: PropTypes.string,
  onChange: PropTypes.func,
  showSizeSelection: PropTypes.bool,
};

export default ProductSwatchSizes;
